"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var TableActionDelete_1 = require("../../../../../../../../shared/components/table_actions/TableActionDelete");
var WrapTableActions_1 = require("../../../../../../../../shared/components/table_actions/WrapTableActions");
var notificationHelper_1 = require("../../../../../../../../shared/helpers/notificationHelper");
var ToolBarButtonsOnly_1 = require("../../../../../../../../shared/components/toolbars/ToolBarButtonsOnly");
var FontAwesome_1 = require("../../../../../../../../shared/components/icons/FontAwesome");
var TableActionConfig_1 = require("../../../../../../../../shared/components/table_actions/TableActionConfig");
var BrandGwsGameProviderList = /** @class */ (function (_super) {
    __extends(BrandGwsGameProviderList, _super);
    function BrandGwsGameProviderList(props) {
        return _super.call(this, props) || this;
    }
    BrandGwsGameProviderList.prototype.componentWillMount = function () {
        var _this = this;
        this.SID_BA = this.props.data.Subscribe("*", function (id, data) {
            _this.setState({
                data: data.data,
                totalRows: data.total
            });
        });
        this.setState({
            data: this.props.data.DATA.data,
            totalRows: 0
        }, function () {
            _this.props.data.LoadData(_this.props.record.key);
        });
    };
    BrandGwsGameProviderList.prototype.componentWillUnmount = function () {
        this.props.data.UnSubscribe(this.SID_BA);
    };
    BrandGwsGameProviderList.prototype.getColumns = function () {
        var _this = this;
        return [
            {
                title: 'Геймпровайдер шлюз',
                dataIndex: this.props.data.dk_gws_gameprovider_title,
                key: this.props.data.dk_gws_gameprovider_title,
                width: 150,
                render: function (text, record, idx) {
                    return React.createElement("div", null,
                        React.createElement(FontAwesome_1.FA, { right: true, icon: "dice" }),
                        " ",
                        record.gws_gameprovider_title);
                }
            }, {
                title: 'Бренд',
                dataIndex: this.props.data.dk_gws_gameprovider_id,
                key: this.props.data.dk_gws_gameprovider_id,
                width: 150,
                render: function (text, record, idx) {
                    return React.createElement("div", null,
                        React.createElement(FontAwesome_1.FA, { right: true, icon: "registered" }),
                        " ",
                        _this.props.record.title);
                }
            }, {
                title: 'Валюта',
                dataIndex: this.props.data.dk_app_currency_id,
                key: this.props.data.dk_app_currency_id,
                width: 150,
                render: function (text, record, idx) {
                    return React.createElement("div", null,
                        React.createElement(FontAwesome_1.FA, { right: true, icon: "coins" }),
                        " ",
                        record.app_currency_title);
                }
            }, {
                title: 'Дата добавления',
                dataIndex: this.props.data.dk_date_added2,
                key: this.props.data.dk_date_added2,
                width: 150,
                align: "center",
                render: function (text, record, idx) {
                    return (React.createElement("div", null, record.date_added2.format(_this.props.state.getDateTimeFormat())));
                }
            }, {
                title: 'Действия',
                key: 'action',
                align: "center",
                render: function (text, record, idx) { return (React.createElement(WrapTableActions_1.default, null,
                    React.createElement(TableActionConfig_1.default, { hint: "\u041D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0430 \u0441\u0435\u0433\u043C\u0435\u043D\u0442\u043E\u0432", onClick: function () { _this.onConfigGwsClick(record); } }),
                    React.createElement(TableActionDelete_1.default, { hint: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C", confirmText: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u044D\u0442\u0443 \u0437\u0430\u043F\u0438\u0441\u044C ?", onClick: function () { _this.onDeleteAccessClick(record); } }))); },
                width: 80
            }
        ];
    };
    BrandGwsGameProviderList.prototype.onConfigGwsClick = function (record) {
        if (this.props.onConfigClick) {
            this.props.onConfigClick(record);
        }
    };
    BrandGwsGameProviderList.prototype.onDeleteAccessClick = function (record) {
        this.props.data.DeleteData(record.key, function () {
            notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                "\u0413\u0435\u0439\u043C\u043F\u0440\u043E\u0432\u0430\u0439\u0434\u0435\u0440 \u0448\u043B\u044E\u0437 ",
                React.createElement("b", null,
                    "[",
                    record.gws_gameprovider_title,
                    "]"),
                " \u0431\u044B\u043B \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0443\u0434\u0430\u043B\u0435\u043D"));
        });
    };
    BrandGwsGameProviderList.prototype.onToolBarClick = function (action) {
        if (action === "refresh") {
            this.props.data.LoadData(this.props.record.key);
        }
        if (action === "create") {
            if (this.props.onCreateClick) {
                this.props.onCreateClick();
            }
        }
        if (action === "back") {
            if (this.props.onGoBackClick) {
                this.props.onGoBackClick();
            }
        }
    };
    BrandGwsGameProviderList.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(ToolBarButtonsOnly_1.default, { hint: { create: "Создать", refresh: "Обновить", back: "Назад" }, onClick: this.onToolBarClick.bind(this) }),
            React.createElement(antd_1.Table, { locale: {
                    filterTitle: 'Поиск',
                    filterConfirm: 'Да',
                    filterReset: 'Сброс',
                    emptyText: 'Нет данных',
                }, bordered: true, columns: this.getColumns(), dataSource: this.state.data, pagination: {
                    pageSize: this.props.state.UITablePageSize,
                    showSizeChanger: true,
                    total: this.state.totalRows,
                    position: "bottom",
                    pageSizeOptions: this.props.state.UITablePageSizeOptions,
                    showQuickJumper: true,
                }, footer: function (data) {
                    return React.createElement("div", null,
                        "\u0412\u0441\u0435\u0433\u043E : ",
                        _this.state.totalRows,
                        " \u0437\u0430\u043F\u0438\u0441\u0435\u0439");
                }, expandedRowRender: function (record) {
                    return (React.createElement("div", null,
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0418\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440 \u0437\u0430\u043F\u0438\u0441\u0438:"),
                            " [",
                            record.key,
                            "] "),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0421\u043E\u0437\u0434\u0430\u043D:"),
                            " [",
                            record.date_added2.format(_this.props.state.getDateTimeFormat()),
                            "] "),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0411\u0440\u0435\u043D\u0434 :"),
                            "[",
                            _this.props.record.title,
                            "]")));
                } })));
    };
    return BrandGwsGameProviderList;
}(React.Component));
exports.default = BrandGwsGameProviderList;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/main_brands_list/ui/component/gateways/gameprovider/BrandGwsGameProviderList.tsx
// module id = 1762
// module chunks = 0